export const defaultEditorHTML = `<p>&nbsp;</p>`;
